/**
 * Transient confirmation of a completed action. Bottom-centered, one at a time.
 * Spec: assets/handoffs/design_system_export/specs/Toast.json
 *
 * Presentational only — always mounted by ToastProvider (even with no active
 * toast) so the role="status" live region exists in the DOM before a message
 * is ever inserted, per the spec's accessibility requirement.
 */
import React from "react";
import classNames from "classnames";
import Icon from "../icons/Icon";
import styles from "./Toast.module.scss";

const ICONS = { success: "CheckCircle", error: "AlertCircle" };

const Toast = ({ toast, onDismiss, onPause, onResume }) => (
  <div
    role="status"
    aria-live="polite"
    className={classNames(styles.root, { [styles["is-visible"]]: !!toast })}
    onMouseEnter={onPause}
    onMouseLeave={onResume}
    onFocus={onPause}
    onBlur={onResume}
  >
    {toast && (
      <>
        <Icon
          name={ICONS[toast.variant] || ICONS.success}
          size={20}
          className={styles[`icon--${toast.variant || "success"}`]}
        />
        <span className={styles.message}>{toast.message}</span>
        {toast.action && (
          <button
            type="button"
            className={styles.action}
            onClick={() => {
              toast.action.onClick?.();
              onDismiss?.();
            }}
          >
            {toast.action.label}
          </button>
        )}
      </>
    )}
  </div>
);

export default Toast;
